import { tryOrElse } from '../error/errorUtils';
const ALL_HASHES_KEY = 'vizcore--all-hash';

/**
 * Dates the hash to the current date and time
 *
 * @param hash Whatever hash you want to store
 * @param now The current date and time in epoch milliseconds
 * @param clientStorage The client storage instance
 */
export async function datesHash(hash, now, clientStorage) {
  const allHashes = await clientStorage.getItem(ALL_HASHES_KEY);
  const allHashesByLastAccess = tryOrElse(() => {
    var _JSON$parse;
    return (_JSON$parse = JSON.parse(allHashes)) !== null && _JSON$parse !== void 0 ? _JSON$parse : {};
  }, e => {
    console.error('Error parsing all hashes', e);
    return {};
  });
  allHashesByLastAccess[hash] = now;
  const val = JSON.stringify(allHashesByLastAccess);
  await clientStorage.setItem(ALL_HASHES_KEY, val);
}

/**
 * Truncates old hashes from the client storage
 *
 * @param clientStorage The client storage instance
 * @param timeToLiveMilliseconds The time to live in milliseconds, defaults to 24 hours
 */
export async function truncateOldHashes(clientStorage, timeToLiveMilliseconds = 24 * 60 * 60 * 1000) {
  const allHashes = await clientStorage.getItem(ALL_HASHES_KEY);
  const allHashesByLastAccess = tryOrElse(() => {
    var _JSON$parse2;
    return (_JSON$parse2 = JSON.parse(allHashes)) !== null && _JSON$parse2 !== void 0 ? _JSON$parse2 : {};
  }, e => {
    console.error('Error parsing all hashes', e);
    return {};
  });
  const timeToLiveAgo = Date.now() - timeToLiveMilliseconds;
  const hashesToDelete = [];
  Object.keys(allHashesByLastAccess).forEach(hash => {
    if (allHashesByLastAccess[hash] < timeToLiveAgo) {
      delete allHashesByLastAccess[hash];
      hashesToDelete.push(hash);
    }
  });
  await Promise.all(hashesToDelete.map(hash => clientStorage.removeItem(hash)));
  await clientStorage.setItem(ALL_HASHES_KEY, JSON.stringify(allHashesByLastAccess));
}